/* global app */
/* global event */
/* global calendar, groups, language, myPositions */
app.controller('ManagerCtrl', ['$rootScope', '$scope', '$http','$compile', 'NetworkService','AtlasDialog','AtlasNotification', function($rootScope, $scope, $http,$compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.fields = {};
    $scope.columnsPerView = 3;
    $scope.actualPage = 1; // Page Id starts with 1
    $scope.htmlClasses = {};
    $scope.calendar = calendar;
    $scope.event = event;
    $scope.gui = {editMode: false}
    $scope.selectedPosition = {};
    $scope.language = language;
    $scope.myPositions = [];
    $scope.myPositionsFilterSwitch = false;
    $scope.myWorks = myWorks;
    
    try{
        for (var key in myPositions) {
         $scope.myPositions.push(myPositions[key].PositionID)
        }
    }catch(Exception){
        console.log("Error parsing myPositions")
    }
    


    $scope.htmlClasses.prevArrow = {
        "ac-icon-button--disabled": true
    }

    $rootScope.$on("updateCalendar", function(){
        var url = window.location.href.split("/");
        var eventId = url[url.length-1]
        NetworkService.callOperation("getmanagercalendar", {eventId:eventId}, function(response){
            var data = response.get("calendar");
            $scope.calendar = data;
            $scope.init()
        })
    })
    
    $scope.getOverlapClass = function(work){
        if($scope.checkIfWorkOverlapsWithExistingWork(work)){
            return "ac-job--overlaps";
        }
    }
    $scope.checkIfWorkOverlapsWithExistingWork = function(actualWork){
        var overlaps = false;
        var work = {
            start: new moment(actualWork.alle_schichten_start),
            end: new moment(actualWork.alle_schichten_ende)
        };
        if(actualWork.Vorname == undefined){
            $scope.myWorks.forEach(function(el){
                var myWork = {
                    start: new moment(el.Startzeit),
                    end: new moment(el.Endzeit)
                };
                
                //Start der Arbeit ist innerhalb anderer Work
                if(work.start>myWork.start && work.start<myWork.end){
                    overlaps =  true;
                }
                
                //Ende der Arbeit ist innerhalb anderer work
                if(work.end>myWork.start && work.end<myWork.end){
                     overlaps =  true;
                }
                var sameStart = work.start.isSame(myWork.start);
                var sameEnd = work.end.isSame(myWork.end);
                if(sameStart && sameEnd){
                     overlaps =  true;
                }
                //console.log(work.start, myWork.start);
    
            })
        }
        return overlaps;
    }
    
    
    $scope.htmlClasses.nextArrow = {
        "ac-icon-button--disabled": false
    }

    $scope.requiredFieldsChecked = function(allFieldsPresent) {
        $scope.gui.okButtonDisabled = !allFieldsPresent
    }

    $scope.openEditPositionDialog = function(position){
        gui.openDialog("editPositionDialog");
        $rootScope.$emit("editPositionDialog", position.position)
    }
    $scope.nextPage = function() {
        var pages = $(".ac-job--col").length / $scope.columnsPerView;
        if ($scope.actualPage < pages) {
            $scope.actualPage++;
            $scope.changePage($scope.actualPage);
            $scope.htmlClasses.prevArrow["ac-icon-button--disabled"] = false;
            if ($scope.actualPage == pages) {
                $scope.htmlClasses.nextArrow["ac-icon-button--disabled"] = true;
            }
        }
    }
    
    $scope.getTranslationTxt = function(germanText, englishText){
        if(englishText == undefined || englishText == "" || englishText == " "){
            return germanText;
        }
        
        if(language == "en"){
            return englishText
        }
        
        return germanText;
    }
    $scope.showPositionInfo = function(position){
        var data = {
            header: "Position Information:",
            headerEn: "Position Information:",
            content: position.alle_positionen_text,
            contentEn: position.alle_positionen_text_en,
            img:"/assets/imgs/posImgs/"+position.alle_positionen_id+".png"
        };
        AtlasDialog.simpleDisplayDialog(function(){
            
        }, function(){
            
        }, data);
    }
    
    $scope.mobilePosChanged = function(){
        var pageId = Object.keys(calendar).indexOf($scope.selectedPosition)+1
        $scope.changePage(pageId)
    }
    
    $scope.eventStateChanged = function(){
        var eventState = {
            eventId: $scope.event.Veranstaltungsnummer,
            eventState: $scope.event.Freigegeben
        }
        NetworkService.callOperation("updateevent", eventState, function(response){
            AtlasNotification.info("Event-Status wurde erfolgreich geändert.");
        })
    }
    
    $scope.safeEventName = function(){
        var eventName = {
            eventId: $scope.event.Veranstaltungsnummer,
            eventName: $scope.event.Veranstaltungsname
        }
        NetworkService.callOperation("updateevent", eventName, function(response){
            AtlasNotification.info("Name der Veranstaltung wurde erfolgreich geändert.");
        })    
    }
    
    $scope.setEditMode = function(){
        $scope.gui.editMode = true;
    }
    
    $scope.openUser = function(userId){
        var win = window.open("/user/"+userId, '_blank');
        win.focus();
    }
    
    $scope.openChangeUserStateDialog = function(){
        var dialogDef = {
            header: "Wähle einen Status",
            notice: "Der User wird über diese Änderung nicht informiert!",
            selected: 1,
            choices: [
                {name: "Angemeldet", value: 1},
                {name: "Akzeptiert", value: 2},
                {name: "Wartend auf User", value: 3}
                ]
        }
        AtlasDialog.simpleChoiceDialog(dialogDef, function(){
            console.log("okay: "+dialogDef.selected)
        }, function(){
            console.log("no")
        })
        
        console.log("done")
    }
    
    $scope.acceptWaitingJob = function(shiftId, positionId, userId){
        AtlasDialog.yesNo("Es wird auf eine interaktion des Users gewartet. Trotzdem freischalten?", function(){
            NetworkService.callOperation("acceptJob", {shiftId: shiftId, positionId: positionId, userId: userId}, function(data, meta){
                AtlasNotification.info("Job erfolgreich akzeptiert");
            })
        }, function(){
            console.log("nein")
        })
    }
    
    $scope.acceptJob = function(shiftId, positionId, userId){
        AtlasDialog.yesNo("Job akzeptieren?", function(){
            NetworkService.callOperation("acceptJob", {shiftId: shiftId, positionId: positionId, userId: userId}, function(data, meta){
                AtlasNotification.info("Job erfolgreich akzeptiert");
            })
        }, function(){
            console.log("nein")
        })
    }

    $scope.prevPage = function() {
        var pages = $(".ac-job--col").length / $scope.columnsPerView;
        if ($scope.actualPage > 1) {
            $scope.actualPage--;
            $scope.changePage($scope.actualPage);
            $scope.htmlClasses.nextArrow["ac-icon-button--disabled"] = false;
            if ($scope.actualPage == 1) {
                $scope.htmlClasses.prevArrow["ac-icon-button--disabled"] = true;
            }
        }
    }

    $scope.changePage = function(pageId) {
        var to = (pageId * $scope.columnsPerView);
        var from = (to - $scope.columnsPerView);

        $(".ac-position-page-button").each(function(id, element) {
            if (id == pageId - 1) {
                $(element).addClass("ac-position-page-button--active")
            }
            else {
                $(element).removeClass("ac-position-page-button--active")
            }
        })

        var i = 0
        for (var positionId in $scope.calendar) {
            if ($scope.calendar[positionId]["gui"] == undefined) {
                $scope.calendar[positionId]["gui"] = {};
            }
            if (i < to && i >= from) {
                $scope.calendar[positionId]["gui"]["isVisible"] = true;
            }
            else {
                $scope.calendar[positionId]["gui"]["isVisible"] = false;
            }
            i++;
        }

        $(".ac-position--header").each(function(id, element) {
            if (id < to && id >= from) {
                $(element).removeClass("ac-position--header--hidden")
            }
            else {
                $(element).addClass("ac-position--header--hidden")
            }
        })
    }

    $scope.init = function() {
        if (window.mobilecheck()) {
            $scope.columnsPerView = 1;
        }
        $scope.changePage(1)
    }

    $scope.init()
}])
initTrip()